
// Initialize models
import "@/models/base";

import { AuthService } from "@/services/auth-service";
import { ToolbarService } from "@/services/toolbar-service";
import { ModalService } from "@/services/modal-service";

import OnBoarding from "@/views/OnBoarding.vue";
import Vue from "vue";
import AppCreateNewBookYear from "../components/bookyear/CreateNewBookYearModal.vue";
import AppUpgradeModal from "../components/common/UpgradeModal.vue";
import AppReportStatus from "../components/reportengine/ReportStatus.vue";
import { Job } from "../models/job";
import { Notification, NotificationTypeError } from "../models/notifications/notification";
import { CalendarReminderNotification } from "../models/notifications/notification-calendar-reminder";
import { BookYearService } from "../services/book-year-service";
import { JobService } from "../services/job-service";
import { NotificationService } from "../services/notification-service";
import { ReportService } from "../services/report-service";
import TheToolbar from "@/components/common/DefaultToolbar.vue";
import { MainSocketService, EVENT_SWITCH_SESSION } from "../services/main-socket-service";
import { UserInfo } from "../models/dossier/user-info";
import AppReportAskedFiltersModal from "@/components/reportengine/ReportAskedFiltersModals.vue";
import { IReportEngineSettingsWrapper } from "../utils/report-engine-settings/report-engine-settings-wrapper";
import {DossierConfigService} from "@/services/dossier-config-service";
import AppSessionSwitchModal from "@/components/common/SessionSwitchModal.vue";
import { ReportType } from "@/utils/report-engine-settings/report-engine-settings";
import { AuthSocketService } from "@/services/auth-socket-service";
import AppNoConnectionModal from "@/components/common/NoConnectionModal.vue";
import { UpgradeService } from "@/services/upgrade-service";
import AppModalServiceContainer from "@/components/modals/ModalServiceContainer.vue";
import { AWSFile } from "@/models/aws-file";
import { AWSFileService } from "@/services";
import AppAwsFilePreviewModal from "@/components/aws-files-modules/AwsFilePreviewModal.vue";
import AppPreviewImageModal from "@/components/common/PreviewImageModal.vue";
import AppPreviewImageListModal from "@/components/common/PreviewImageListModal.vue";
import AppAwsFilesModalList from "@/components/common/AwsFilesModalList.vue";
import AppLockScreen from "@/components/LockScreen.vue";
import {trackPageView} from "@/utils/analytics";

export default Vue.extend({
	data() {
		return {
			AuthService,
			ModalService,
			DossierConfigService,
			showRoute: true,
			showTimedOut: false,
			queuedReport: null as null | Job,
			JobService,
			switchSessionModalOpen: false,
			switchSessionCallbacks: [] as Function[],
			showRestartButton: false,
			upgradeTier: 0,
			showUpgradeModal: false,
			createReportSettings: null as null | {settings:IReportEngineSettingsWrapper, type:ReportType},
			initModal: true,
			MainSocketService,
			AuthSocketService,
			toPreviewAwsFiles: [] as AWSFile[],

		};
	},
	computed: {
		loggedIn(): boolean {
			return this.AuthService.isLoggedIn;
		},
		wfUser(): UserInfo {
			return this.AuthService.wfUser;
		},
		appReady():boolean{
			return this.AuthService.appReady;
		},
		isPlanExpired():boolean {
			return this.AuthService.wfCompany.isExpired();
		},
		isBlocked():boolean{
			return this.AuthService.wfCompany.Blocked;
		},
		isInAccountRoute():boolean{
			return this.$route.path.startsWith("/account");
		},
		areSocketsConnected():boolean {
			return this.MainSocketService.isConnected() && this.AuthSocketService.isConnected();
		},
		imageUrl():string{
			return this.ModalService.openImages[this.ModalService.openImages.length - 1] || "";
		},
		imageUrlList():string[] | undefined{
			return this.ModalService.openImageLists[this.ModalService.openImageLists.length - 1];
		}
	},
	watch: {
		// Refresh when dossier is changed
		async "AuthService.selectedDossier"(newVal: string, oldVal: string) {
			if (newVal == oldVal) {
				return;
			}
			this.showRoute = false;
			await this.$nextTick();
			this.showRoute = true;
		},
		"$route.path"() {
			ToolbarService.title = "";
			trackPageView();
		},
		appReady: {
			immediate: true,
			handler(){
				setTimeout(() => this.showTimedOut = true, 10000);
				if (!this.appReady) return;
				this.initModal = !this.AuthService.isDossierInitialized;
				let splashEl = document.getElementById("splash");
				if (!splashEl) return;
				splashEl.remove();
				this.showRestartButton = false;
				this.checkPlanExpired();
				this.checkIfBlocked();
			}
		},
		showTimedOut: {
			immediate: true,
			handler(){
				if(this.showTimedOut){
					let s = document.getElementById("splash");
					let r = document.getElementById("refresh");
					if(s && ! r){
						s.innerHTML += "<div id='refresh'>" +
							"<div class='info'>"+this.$ct("time-out-title").toString()+"</div> " +
							"<div class=\"w-button\" onclick=\"window.location.href = `${window.location.origin}?v=${Math.random()}`\">" +
							""+this.$ct("time-out-btt-title").toString()+
							"</div><div class=\"w-button cancel mls\" onclick=\"window.location.href = `${window.location.origin}/logout`\">" +
							""+this.$ct("logout").toString()+"</div></div>";
					}
				}
			}
		},
		isPlanExpired: {
			immediate: true,
			handler(){
				this.checkPlanExpired();
			}
		},
		"AuthService.isLoggedIn"(){
			this.$router.push("/login");
		}
	},
	methods: {
		async checkPlanExpired(){
			if (!this.AuthService.isLoggedIn) return;
			if((this.isPlanExpired && this.appReady)){
				if (!this.isInAccountRoute){
					await this.$router.push("/account");
				}
			}
		},
		async checkIfBlocked(){
			if((this.isBlocked && this.appReady)){
				await this.$router.push("/problem");
			}
		},
		async logout() {
			await AuthService.logout();
		},
		onJobCrash(job: Job) {
			this.$wf.notify(this.$ct("job-crashed", {name: job.Name}), "danger", 3000, "exclamation-triangle");
		},
		onJobFinished(job: Job) {
			this.$wf.notify(this.$ct("job-finished", {name: job.Name}), "success", 3000, "check");
		},
		onNewNotification(notification: Notification) {
			let className = "info";
			let icon = "comment-alt";
			if (notification.Type == NotificationTypeError) {
				className = "danger";
				icon = "exclamation-triangle";
			}
			if (notification instanceof CalendarReminderNotification) {
				icon = "calendar-alt";
				this.showBrowserNotification(notification);
			}
			this.$wf.notify(notification.getShortTitle(), className, 3000, icon);
		},
		showBrowserNotification(notification: CalendarReminderNotification) {
			if (typeof window == "undefined" || !("Notification" in window)) return;
			if (window.Notification.permission != "granted") return;
			let browserNotification = new window.Notification(notification.getShortTitle(), {
				body: notification.getMessage(),
				tag: `calendar-reminder-${notification.Data?.EventID || notification.ID}`
			});
			browserNotification.onclick = () => {
				window.focus();
				this.$router.push(notification.getRoute()).catch(() => {});
				browserNotification.close();
			};
		},
		onReportQueued(job: Job) {
			if (this.queuedReport) return;
			this.queuedReport = job;
			//this.$wf.dialog(this.$ct("report-queued"), this.$ct("common.Ok"), this.$ct("common.info"));
		},
		onReportCreate(settings:IReportEngineSettingsWrapper, reportType:ReportType){
			this.createReportSettings = {settings, type: reportType};
		},
		onBecameActiveSession(){
			this.switchSessionModalOpen = false;
			for (let callback of this.switchSessionCallbacks) {
				callback(true);
			}
			this.switchSessionCallbacks = [];
		},
		async askToSwitchSession(callback?:Function) {
			if (callback && typeof(callback) == "function") {
				this.switchSessionCallbacks.push(callback);
			}
			if (this.switchSessionModalOpen) {
				return;
			}
			this.switchSessionModalOpen = true;

		},
		async onSwitchSessionCallback(shouldSwitch:boolean){
			this.switchSessionModalOpen = false;
			if (shouldSwitch) {
				await MainSocketService.emit(EVENT_SWITCH_SESSION);
			}else{
				for (let callback of this.switchSessionCallbacks) {
					callback(false);
				}
				this.switchSessionCallbacks = [];
				await AuthService.logout();
			}
		},
		showError(error:string){
			this.$wf.notify(this.$ct(`errors.${error}`), "danger", 3000, "exclamation-triangle");
		},
		onInitFailure(){
			this.showRestartButton = true;
		},
		clearApp(){
			AuthService.logout();
			location.reload();
		},
		checkIfOnboardingFinished(){
			this.initModal = !AuthService.isDossierInitialized;
		},
		async goToHome(){
			if (this.$route.path == "/home") {
				this.showRoute = false;
				await this.$nextTick();
				this.showRoute = true;
			}else{
				this.$router.push("/home");
			}
		},
		onUpgradeModal(tier:number){
			this.upgradeTier = tier;
			this.showUpgradeModal = !this.showUpgradeModal;
		},
		previewAwsFile(file:AWSFile){
			if(file.shouldOpenInModal()){
				let url = file.getUrl();
				window.open(url, "_blank");
			}else{
				this.toPreviewAwsFiles.push(file);
			}
		},
		removeAwsFilePreview(i:number){
			this.toPreviewAwsFiles.splice(i,1);
		},
		closePreviewImage(){
			this.ModalService.openImages.pop();
		},
		closePreviewImageList(){
			this.ModalService.openImageLists.pop();
		},
		onCompanyUpdate(){
			if (AuthService.wfCompany.Blocked){
				this.$router.push("/problem");
			}
		}
	},
	created() {
		NotificationService.on("new-notification", this.onNewNotification);
		ReportService.$on("report-queued", this.onReportQueued);
		ReportService.$on("create-report", this.onReportCreate);
		MainSocketService.on("/session-switched", this.askToSwitchSession, this);
		MainSocketService.on("/active-session", this.onBecameActiveSession, this);
		AuthService.on("other-session-active", this.askToSwitchSession);
		AuthService.on("error", this.showError);
		AuthService.on("init-failure", this.onInitFailure);
		AuthService.on("company-update", this.onCompanyUpdate);
		BookYearService.on("bookyear-changed", this.goToHome);
		UpgradeService.on("show-upgrade-modal",this.onUpgradeModal);
		AWSFileService.on("preview-file", this.previewAwsFile);
		if (!this.loggedIn) {
			let splashEl = document.getElementById("splash");
			if (!splashEl) return;
			splashEl.remove();
		}
	},
	destroyed() {
		NotificationService.off("new-notification", this.onNewNotification);
		ReportService.$off("report-queued", this.onReportQueued);
		ReportService.$off("create-report", this.onReportCreate);
		AuthService.off("other-session-active", this.askToSwitchSession);
		AuthService.off("error", this.showError);
		AuthService.off("init-failure", this.onInitFailure);
		BookYearService.off("bookyear-changed", this.goToHome);
		UpgradeService.off("show-upgrade-modal",this.onUpgradeModal);
		AWSFileService.off("preview-file", this.previewAwsFile);
		AuthService.off("company-update", this.onCompanyUpdate);
		MainSocketService.offAll(this);
	},
	components: {
		OnBoarding,
		TheToolbar,
		AppCreateNewBookYear,
		AppReportStatus,
		AppReportAskedFiltersModal,
		AppSessionSwitchModal,
		AppNoConnectionModal,
		AppUpgradeModal,
		AppModalServiceContainer,
		AppAwsFilePreviewModal,
		AppPreviewImageModal,
		AppPreviewImageListModal,
		AppAwsFilesModalList,
		AppLockScreen
	},
	i18nEx: {
		componentPrefix: "views.TheMain"
	}
});
